export default __webpack_public_path__ + "beta-maps-guides-migrate-expressions-960-b3779692820cb7de07898bc22ef6d008.png";